import type { IValidatorParams } from "@edaz/services/baseValidationService";
import padStart from "lodash/padStart";
import { isBankPrefixNumber } from "./isBankPrefixNumber";

export function validateModulo(variable: string, weights: number[]) {
  return weights.map((n, i) => n * parseInt(variable[i])).reduce((a, b) => a + b, 0) % 11 === 0;
}

export interface IsBankAccountNumberOptions {
  prefix: boolean;
  bankCode: boolean;
  validate?: (entity: any) => boolean;
}

export function addDashToAccountNumber(value: string) {
  // Add dash if account number is longer than 10
  if (/^[0-9]{11,16}/.test(value)) {
    let lengthBeforeSlash;
    if (~value.indexOf("/")) {
      lengthBeforeSlash = value.indexOf("/");
    } else {
      lengthBeforeSlash = value.length;
    }

    return `${value.slice(0, lengthBeforeSlash - 10)}-${value.slice(lengthBeforeSlash - 10)}`;
  }

  return value;
}

export function isBankAccountNumber(value: string | undefined, options: IsBankAccountNumberOptions, params?: IValidatorParams) {
  if (options.validate && !options.validate(params?.entity)) {
    return true;
  }

  // logic borrowed from http://www.michalhaltuf.cz/blog/2016/04/validace-cisla-bankovniho-uctu-v-php/
  let regex;

  if (options.bankCode && options.prefix) {
    regex = /^(([0-9]{0,6})-)?([0-9]{2,10})\/[0-9]{4}$/;
  } else if (options.prefix) {
    regex = /^(([0-9]{0,6})-)?([0-9]{2,10})$/;
  } else if (options.bankCode) {
    regex = /^([0-9]{1,10})\/[0-9]{4}$/;
  } else {
    regex = /^([0-9]{1,10})$/;
  }

  let modifiedValue = value ? value.replace(" ", "") : "";
  modifiedValue = addDashToAccountNumber(modifiedValue);

  let valid = regex.test(modifiedValue);

  if (valid) {
    const dashSplit = modifiedValue.split("-");

    if (options.prefix) {
      if (dashSplit.length === 2) {
        valid = isBankPrefixNumber(dashSplit[0]);
      } else {
        valid = true;
      }
    }

    const accountNumber = padStart(dashSplit[dashSplit.length - 1].split("/")[0], 10, "0");
    if (valid) {
      valid = validateModulo(accountNumber, [6, 3, 7, 9, 10, 5, 8, 4, 2, 1]);
    }
  }

  return valid;
}
